import { LinkUIBasic, LinkUITealBoldUnderlined } from "./common_links";
import { BRR } from "./common_ui_components";

/**
 *  connect with founder on linkedin and
 *  book meeting on topmate
 */
function ConnectAndBook(){
    return (
<div className="flex flex-col w-full">
  
  <div className='flex flex-row-responsive 
items-center justify-center rounded-xl bg-gray-200 '>

<div className='flex flex-col text-center
  p-8 m-8 leading-8 font-mono'>
 <a 
    href = "https://www.linkedin.com/in/prashant-priyadarshi-2705334a/" target="_blank">
    If you loved the AI Coach, let me know!  <BRR /> 
    If you hated it, I definitely want to hear why. <br />
    Let's connect on 
    &nbsp;
    <span className="text-gray-700 font-semibold underline">
      LinkedIn</span>
  </a>
{
  <div>
     <LinkUITealBoldUnderlined
url= "https://topmate.io/prashant_priyadarshi"
text="Book LLD Mock Interview with me" />
    </div>
}
{ false &&
<div>
   <br />
  Book LLD Mock Interview With Me through 
 <span> 
   <LinkUIBasic
url= "https://topmate.io/prashant_priyadarshi"
text="TopMate" /> or 
{   
 <LinkUIBasic
      url= "https://www.meetapro.com/mock-interview/mock-interview-for-low-level-design-lld-round-1071105"
      text="MeetAPro (USA)" />  
}
</span> 
</div>
}
</div>

{
<div className="flex flex-col">
<img className=' w-48 rounded-3xl bg-white'   
          src="https://public-items-1.s3.ap-south-1.amazonaws.com/codezym/face/canva_face_low_quality_6_20kb.jpg"
      />
      
      <div className="text-gray-700 text-center
       text-sm font-mono mt-2">
        Prashant Priyadarshi <br /> Founder, MockGym</div>
</div>
}
</div>
</div>
    
    );
}

export {ConnectAndBook};